import { render } from "./CampaignNameBlock.vue?vue&type=template&id=663ecd91"
import script from "./CampaignNameBlock.vue?vue&type=script&lang=js"
export * from "./CampaignNameBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/CampaignNameBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "663ecd91"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('663ecd91', __exports__)) {
    api.reload('663ecd91', __exports__)
  }
  
  module.hot.accept("./CampaignNameBlock.vue?vue&type=template&id=663ecd91", () => {
    api.rerender('663ecd91', render)
  })

}


export default __exports__